import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { MessageService } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { finalize } from 'rxjs';
import { PrimeNgModule } from 'src/app/shared/prime-ng/prime-ng.module';
import { TramiteEstadoReq } from 'src/app/users/tramites/tramite-exclusion/interface/TramiteEstadoReq';
import { TramiteExclusionRes } from 'src/app/users/tramites/tramite-exclusion/interface/TramiteExclusionRes';
import { TramiteExclusionService } from 'src/app/users/tramites/tramite-exclusion/tramite-exclusion.service';

@Component({
  selector: 'app-display-tramites-exclusion',
  standalone: true,
  imports: [
        CommonModule,
        TableModule,
        TagModule,
        AccordionModule,
        TabViewModule,
        TooltipModule,
        InputNumberModule,
        PrimeNgModule
  ],
  providers: [MessageService],
  templateUrl: './display-tramites-exclusion.component.html',
  styleUrl: './display-tramites-exclusion.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayTramitesExclusionComponent {
    @Input() exclusiones: TramiteExclusionRes[] = [];

    @Output() estadoActualizado = new EventEmitter<void>();
    cargandoEstado: Set<number> = new Set();

    constructor(
        private tramiteService: TramiteExclusionService,
        private messageService: MessageService
    ) {}

    cambiarEstado(tramite: TramiteExclusionRes, nuevoEstado: boolean): void {
        const body: TramiteEstadoReq = {
            idTramiteExclusion: tramite.idTramiteExclusion,
            estado: nuevoEstado
        };

        this.cargandoEstado.add(tramite.idTramiteExclusion);

        this.tramiteService.cambiarEstadoTramiteExclusion(body).subscribe({
            next: () => {
                tramite.estado = nuevoEstado;
                this.estadoActualizado.emit();
                this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: `Estado ${nuevoEstado ? 'activado' : 'desactivado'} correctamente`
                });
            },
            error: () => {
                this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo cambiar el estado del trámite.'
                });
            },
            complete: () => {
            this.cargandoEstado.delete(tramite.idTramiteExclusion);
        }});
    }
}
